module.exports = __webpack_public_path__ + "img/image5.0450f967.png";